import { withRouter } from 'react-router-dom';
import { withUser } from 'components/queries/GetUserQuery';

import ManageHotelContainer from './ManageHotelContainer';

export default withRouter(withUser(ManageHotelContainer));
